/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  Authentication,
  AuthenticationInterface,
} from "../Authentication";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "selector",
        type: "bytes4",
      },
    ],
    name: "getActionId",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class Authentication__factory {
  static readonly abi = _abi;
  static createInterface(): AuthenticationInterface {
    return new utils.Interface(_abi) as AuthenticationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Authentication {
    return new Contract(address, _abi, signerOrProvider) as Authentication;
  }
}
